mutation DeleteAliyah($id: ID!) {
  deleteAliyah(id: $id) {
    ok
    errors
  }
}
